import React from 'react';
import { motion } from 'framer-motion';
import { mockData } from '../data/mock';
import { Star } from 'lucide-react';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.15 } })
};

const Testimonials = () => {
  const { testimonials } = mockData;

  return (
    <section 
      id="testimonials" 
      className="py-24 sm:py-32 relative overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Background texture */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.prod-images.emergentagent.com/jobs/e29e1e74-dfad-4ff0-a54e-5cee69b74787/images/82b61847245c4c97e248a5bf1c1eabb4ee44e565a8a3a92fecdf9cea5ae9e63c.png"
          alt=""
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-[#FAFAF9]/85" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          custom={0}
        >
          <span 
            className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Témoignages
          </span>
          <h2 
            className="mt-4 text-4xl sm:text-5xl tracking-tight leading-tight font-normal text-[#1C1917]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Ce que disent nos clients
          </h2>
        </motion.div>

        {/* Testimonial cards */}
        <div className="grid md:grid-cols-3 gap-8" data-testid="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              className="bg-white/70 backdrop-blur-sm rounded-2xl p-8 border border-[#E8D5D1]/30 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              variants={fadeUp}
              custom={index + 1}
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {Array.from({ length: testimonial.rating }, (_, i) => (
                  <Star key={i} className="w-4 h-4 text-[#D4AF37] fill-current" />
                ))}
              </div>
              
              {/* Quote */}
              <blockquote 
                className="text-lg italic text-[#1C1917] leading-relaxed mb-8"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                "{testimonial.text}"
              </blockquote>
              
              {/* Author */}
              <div className="border-t border-[#E8D5D1]/30 pt-4">
                <div 
                  className="font-medium text-[#1C1917]"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {testimonial.name}
                </div>
                <div 
                  className="text-sm text-[#A8A29E] mt-0.5"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {testimonial.location}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Rating summary */}
        <motion.div
          className="mt-16 text-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={4}
          data-testid="testimonials-cta"
        >
          <div className="inline-flex items-center gap-3 bg-white/60 backdrop-blur-sm rounded-full px-6 py-3 border border-[#E8D5D1]/30">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }, (_, i) => (
                <Star key={i} className="w-4 h-4 text-[#D4AF37] fill-current" />
              ))}
            </div>
            <span className="text-sm font-medium text-[#57534E]" style={{ fontFamily: "'Outfit', sans-serif" }}>
              4.9/5 — Plus de 100 avis clients
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
